/**
 * Supported currencies for invoices and offers.
 * These currencies are available for coaches to use when creating invoices and offers.
 */
export const COACH_CURRENCIES = [
  "USD",
  "EUR",
  "GBP",
  "JPY",
  "CHF",
  "CAD",
  "AUD",
  "CNY",
  "INR",
  "NZD",
  "NOK",
] as const;

export type CoachCurrency = (typeof COACH_CURRENCIES)[number];
